export default __webpack_public_path__ + "static/media/dtsu5168_direct_gw152.c45b9d57.jpg";